module.exports = __webpack_public_path__ + "img/xp2.183343ce.jpg";